import MobileAsideMenu from './MobileAsideMenu';

export default MobileAsideMenu;
